export const MENU = {
    itemDashbord: 'Tableau de bord',
    itemListeRecom: 'Liste des recommandations',
    itemListeClient: 'Liste des clients',
    itemParametre: 'Paramétrages',
  };
  